import {getArticles} from '@api'

export class ArticleListModel {
  constructor () {
    this.items = []
    this.loading = false
  }

  async load () {
    try {
      if (this.loading) {
        return
      }

      this.loading = true
      const rb = await getArticles()

      this.loading = false

      if (rb && rb.status === 'success') {
        this.items = rb.data
      }
      else {
        throw new Error(rb.message)
      }
    }
    catch (err) {
      this.loading = false
      alert(err.message)
    }
  }
}
